import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Editor } from "../editor/Editor";
import { useEffect, useRef, useState } from "react";
import CmsService from "../../../service/CmsService";
import { useNavigate, useParams,useSearchParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import { TempBasic } from "../temp/TempBasic";
import { TempSettingsDialog } from "./TempSettings";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";

export function TempEditPageUpdate({id})
{
    let params = useParams();
    id = params.id;
    const [temp,setTemp] = useState(null);

    useEffect(()=>{
    },[]);
    useEffect(()=>{
        setTemp(null);
        CmsService.getTemp(id).then((ret)=>{
            console.log('grp:'+JSON.stringify(ret));
            setTemp(ret);
        })
    },[id]);

    return (temp!=null?<TempEditPage tmp={temp}/>:<></>)
}
export function TempEditPageNew()
{
    const {t}=useTranslation();
    const temp={temp:{name:''},settings:{pageSize:'A4',orientation:'Portrait',columns:1,columnGap:5,
        leftMargin:20,rightMargin:20,topMargin:20,bottomMargin:20,        
        pretext:true,pretextBreak:true,pretextFull:true,
        posttext:false,posttextBreak:false,posttextFull:true,
        sectPretext:true,sectPretextBreak:false,sectPretextFull:true,
        sectPosttext:false,sectPosttextBreak:false,sectPosttextFull:true
    },dats:[]};
    return <TempEditPage tmp={temp}/>;
}
export function TempEditPage({tmp})
{
    const {t}=useTranslation();    
    let navigate = useNavigate();

    console.log("TempEditPage:"+" temp.id:"+tmp.id);
    const [sessionId,setSessionId] = useState('');
    const [temp,setTemp]=useState(tmp.temp);
    const [ts,setTs]=useState(tmp.settings);
    const [modified,setModified]=useState(true);
    const [settingsDialog,setSettingsDialog]=useState(false);
    const [contentIndex,setContentIndex]=useState(0);

    const editor = useRef(null);
    const messages = useRef([]);

    const contentTypes=[
        {label:t('TempPart.testBody'),value:'TESTBODY',varname:'testBody'},
        {label:t('TempPart.pretext'),value:'PRETEXT',varName:'pretext'},
        {label:t('TempPart.posttext'),value:'POSTTEXT',varName:'postText'},
        {label:t('TempPart.secPretext'),value:'SECTPRETEXT',varName:'sectPretext'},
        {label:t('TempPart.sectPosttext'),value:'SECTPOSTTEXT',varName:'sectPosttext'}
    ]
    const toolBarStart=()=>{
        return( 
        <>
            <div className="flex gap-2 align-items-baseline">
                <div><label for="templateName">{t('Template_Name')}</label></div>
                <div className="col">
                    <InputText id="templateName" onChange={onNameChange} value={temp.name}></InputText>
                </div>
                <div>{temp.id!=undefined?'ID: '+temp.id:''}</div>
            </div>
        </>
        )
    }
    const toolBarEnd=()=>{
        return(
            <div className="flex gap-2">
                <Button severity="primary" icon="pi pi-wrench" label={t('Settings')} onClick={onOpenSettings}></Button>
                <Button severity="primary" icon="pi pi-save" label={t('Save')} onClick={onSave} disabled={!modified}></Button>
            </div>
        )
    }
    const onOpenSettings=()=>{
        setSettingsDialog(true);
    }
    const applySettings=(ts)=>{
        var ps={pageSize:ts.pageSize,orientation:ts.orientation,leftMargin:ts.leftMargin,rightMargin:ts.rightMargin,
            topMargin:ts.topMargin,bottomMargin:ts.bottomMargin,headerFromTop:0,footerFromBottom:0
        };
        var cs={columns:ts.columns,columnGap:ts.columnGap};
        var csFull={columns:1,columnGap:0};

        contentTypes.forEach((ct)=>{
            editor.current.setPageSettings(ct.value,ps);
            if(ct.value!='TESTBODY' && ts[ct.varName+'Full'])
                editor.current.setColumnSettings(ct.value,csFull);
            else
                editor.current.setColumnSettings(ct.value,cs);
        })
    }
    const onSettingsOK=(ts)=>{
        setTs(ts);
        setModified(true);
        setSettingsDialog(false);
        applySettings(ts);
    }
    const onSettingsCancel=(ts)=>{
        setSettingsDialog(false);
    }

    const onSave=()=>{
        if(!checkValues())
            return;
        editor.current.save(temp.id,'BODY').then((saveInfos)=>{
            var datsSaved=[];
            var sessions=[];
            saveInfos.forEach((si)=>{
                datsSaved=datsSaved.concat(si.dats);
                sessions.push(si.sessionId);
            });

            var tempDto={temp:temp,sessions:sessions,settings:ts};
            if(temp.id == undefined)
            {
                CmsService.createTemp(tempDto).then((ret)=>{
                    console.log("saved:"+JSON.stringify(ret));
                    setTemp(ret.temp); 
                    setModified(false);
                }).catch((e)=>{
                    if(e.response.status == 403)
                        showError('Permission denied');
                    else
                        showError(e.message);
                });
            }
            else
            {
                CmsService.updateTemp(temp.id,tempDto).then((ret)=>{
                    console.log("saved:"+JSON.stringify(ret));
                    setTemp(ret.temp); 
                    setModified(false);
                });
            }
        })
    };
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t("@error."+err)});
	}	
    const checkValues=()=>{
        if(temp.name == undefined || temp.name.trim().length == 0)
        {
            showError('Name_is_empty');
            return false;    
        }
        return true;
    };
    const onDocumentModified=()=>{
        if(!modified)
            setModified(true);
    } 
    const onBasicChange=(q)=>{
        var qu={...temp,...q};
        setTemp(qu);
        setModified(true);
    }
    const onNameChange=(e)=>{
        var qu={...temp};
        qu.name=e.target.value;
        setTemp(qu);
        setModified(true);
    }
    const onChangeContent=(e)=>{
        setContentIndex(e.index);
        editor.current.onChangeContent(contentTypes[e.index].value);
    }
    useEffect(()=>{
    },[ts])
    
    return(
        <>
        <Card className="col-12 xl:col-8">
         <Toolbar start={toolBarStart} end={toolBarEnd}/>
         <Messages ref={messages}></Messages>         
         <TabView className="mt-2" renderActiveOnly={true} onTabChange={onChangeContent} activeIndex={contentIndex}>
            <TabPanel header={t("TempPart.testBody")}></TabPanel>
            <TabPanel header={t("TempPart.pretext")} disabled={!ts.pretext}></TabPanel>
            <TabPanel header={t("TempPart.posttext")} disabled={!ts.posttext}></TabPanel>
            <TabPanel header={t("TempPart.sectPretext")} disabled={!ts.sectPretext}></TabPanel>
            <TabPanel header={t("TempPart.sectPosttext")} disabled={!ts.sectPosttext}></TabPanel>
         </TabView>   
         <Editor ref={editor} dats={tmp.dats} t={t} options={0} onModified={onDocumentModified} ctypes={contentTypes} 
            defFont={'Noto Sans'} defFontSize={10} mode="temp"></Editor>
        </Card>
        {settingsDialog?
            <TempSettingsDialog visible={settingsDialog} settings={ts} onOK={onSettingsOK} onCancel={onSettingsCancel}></TempSettingsDialog>:''
        } 
        </>
    )
}